var React = require('react');
var createReactClass = require('create-react-class');
var ContentSlot = require('./contentSlot.jsx');

var PostModule = createReactClass({

	render: function () {
        var contentSlotNodes = this.props.postModule.fields.contentSlots.map(function(contentSlot, index){
            return <ContentSlot contentSlot={contentSlot} layoutType={this.props.postModule.fields.layoutType} key={index} />;
        }.bind(this));

        return (
            <div className={'postModule layout-type-' + this.props.postModule.fields.layoutType.toLowerCase()}>
                {contentSlotNodes}
            </div>
        );
    }
});

module.exports = PostModule;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/postModule.jsx